// extracted by mini-css-extract-plugin
export var container = "blogPostBody-module--container--f647b";
export var htmlEmbed = "blogPostBody-module--htmlEmbed--23098";
export var imgCtn = "blogPostBody-module--imgCtn--8f637";
export var internalAd = "blogPostBody-module--internalAd--8d473";
export var videoCtn = "blogPostBody-module--videoCtn--aac82";
export var wistiaEmbed = "blogPostBody-module--wistiaEmbed--aabee";